import { render, staticRenderFns } from "./externalEmailPreviewComponent.vue?vue&type=template&id=15099a12&"
import script from "./externalEmailPreviewComponent.vue?vue&type=script&lang=js&"
export * from "./externalEmailPreviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports